import { z } from "zod";
import { SiteSchema } from "../site/SiteSchema";
import { dateRequired } from "../order/OrderSchema";


export type BookingInfoSchema = {
  bookingId: string|null;
  spotId: string;
  spotName: string;
  bookingBegin: Date;
  bookingEnd: Date | null;
  orderId: string;
  
  //verified: boolean;
  statusId: number;
  length: number;
  assignedLoop?: number | null; 
  // days?: number; 
};


export const BookingSchema = z.object({
  customerId: z.string().uuid().optional().nullable(),
  orderId: z.string().uuid(),
  orderDesc: z.string().optional().nullable(),
  bookingId: z.string().uuid().optional().nullable(),
  customer: z.string().optional().nullable(),
  spotId: z.string().uuid(),
  bookingBegin: dateRequired,
  bookingEnd: dateRequired,
  sites: z.array(SiteSchema).default([])
})
